import { Avatar, Popover } from 'antd';
import robotImg from 'assets/images/robot.png';
import { LocalMessage } from 'hooks/business/conversation';
import { buyerNickMask } from 'services/channels/demo';
import { UIMessages } from '../../useChatView';
import BuyerDetail from '../BuyerDetail';
import { useGetAvatarSrc } from 'lib/utils/platformImage';
import { css } from '@emotion/css';
import { ChannelIcon } from 'views/Conversation/ConvList/ChannelIcon';

interface MessageExtendAvatarProps {
  raw: LocalMessage;
  msg: UIMessages;
  conversation: Conversation.Conversation;
  isRobotMessage: boolean;
  isBuyerMessage: boolean;
}

export const MessageExtendAvatar = (props: MessageExtendAvatarProps) => {
  const { isRobotMessage, isBuyerMessage, conversation, msg } = props;

  const { nickName } = msg;
  const { buyerNick, channel, region, buyerAvatar, topBarInfo } = conversation;

  const getAvatarSrc = useGetAvatarSrc();

  if (msg.raw.msgFromType === 'MERCADO2ASSISTANT') {
    return (
      <div className="flex items-center justify-center w-[28px] h-[28px] bg-[var(--avatar-name-bg)] rounded-full">
        <ChannelIcon className="w-5 h-5" channel="MERCADO" />
      </div>
    );
  }

  if (isRobotMessage) {
    return <Avatar className="!w-full !h-full" shape="square" src={robotImg} />;
  } else if (isBuyerMessage) {
    return (
      <Popover
        trigger="click"
        placement="bottomLeft"
        content={
          <BuyerDetail
            platform={channel}
            region={region}
            nick={buyerNickMask(buyerNick ?? nickName ?? '')}
            avatar={buyerAvatar ? getAvatarSrc(buyerAvatar, channel) : undefined}
          />
        }
      >
        {buyerAvatar ? (
          <Avatar
            shape="square"
            src={buyerAvatar ? getAvatarSrc(buyerAvatar, channel) : undefined}
          />
        ) : (
          <span className={avatarName}>{nickName.substr(0, 2)}</span>
        )}
      </Popover>
    );
  } else {
    const name = nickName ?? topBarInfo?.storeAlias ?? topBarInfo?.storeName ?? '';
    return <span className={avatarName}>{name.substr(0, 2)}</span>;
  }
};

export const avatarName = css`
  display: block;
  height: 100%;
  font-size: 16px;
  color: var(--fett-text-tertiary);
  font-weight: 500;
  background-color: var(--avatar-name-bg);
`;
